import { useMutation } from "@tanstack/react-query";
import api, { type ApiError } from "../api/http";
import type { MessageResponse } from "../api/types";

/** Re-send the email-verification link for an unverified account.
 * The endpoint is enumeration-safe and rate-limited server-side. */
export function useResendVerification() {
  return useMutation<MessageResponse, ApiError, { email: string }>({
    mutationFn: (data) => api.post("/api/v1/auth/resend-verification/", data),
  });
}
